import { render, staticRenderFns } from "./APP3.vue?vue&type=template&id=422ec977&scoped=true"
import script from "./APP3.vue?vue&type=script&lang=js"
export * from "./APP3.vue?vue&type=script&lang=js"
import style0 from "./APP3.vue?vue&type=style&index=0&id=422ec977&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422ec977",
  null
  
)

export default component.exports